import { render, staticRenderFns } from "./sky-order-inquiry.vue?vue&type=template&id=2265b05e&scoped=true"
import script from "./sky-order-inquiry.vue?vue&type=script&lang=js"
export * from "./sky-order-inquiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2265b05e",
  null
  
)

export default component.exports